import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CANONICAL_DOMAIN = process.env.REACT_APP_BASE_URL || 'https://www.wizehelper.com';

/**
 * A component that adds and updates the canonical link tag in the document head.
 * This is crucial for SEO to prevent duplicate content issues by specifying the
 * "preferred" version of a URL.
 */
function Canonical() {
  const location = useLocation();

  useEffect(() => {
    // Find existing canonical tag
    let link = document.querySelector("link[rel='canonical']");

    // If it doesn't exist, create it and append to the head
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }

    // Construct the canonical URL from the domain and current pathname
    const canonicalUrl = `${CANONICAL_DOMAIN}${location.pathname}`;

    // Set the href attribute of the link
    link.setAttribute('href', canonicalUrl);

  }, [location]); // Re-run when location changes

  // This component does not render anything to the DOM
  return null;
}

export default Canonical;
